/**
 * Generate a deterministic hue from a card title's first character.
 * Uses golden ratio distribution for well-spaced hues.
 * @param {string} title
 * @returns {number} Hue value 0-360
 */
export function getTitleHue(title) {
    if (!title) return 0;
    const code = title.charAt(0).toUpperCase().charCodeAt(0);
    return Math.round((code * 137.508) % 360);
}

/**
 * Get accent bar color for a card title.
 * @param {string} title
 * @returns {string} HSL color string
 */
export function getCardAccentColor(title) {
    const hue = getTitleHue(title);
    return `hsl(${hue}, 55%, 50%)`;
}

/**
 * Get faint background wash for a card title.
 * @param {string} title
 * @param {boolean} isDark - Whether dark mode is active
 * @returns {string} HSL color string
 */
export function getCardWashColor(title, isDark) {
    const hue = getTitleHue(title);
    if (isDark) {
        return `hsl(${hue}, 15%, 13%)`;
    }
    return `hsl(${hue}, 25%, 97%)`;
}
